import type { ComponentProps } from "react";
import { AccessoryCustomizationModal } from "@ui/components/AccessoryCustomizationModal";
import { FaceAccessoryModal } from "@ui/components/FaceAccessoryModal";

type FaceAccessoryModalProps = ComponentProps<typeof FaceAccessoryModal>;
type AccessoryCustomizationModalProps = ComponentProps<typeof AccessoryCustomizationModal>;

type ConfiguratorAccessoryModalsProps = {
  faceAccessoryModalProps: FaceAccessoryModalProps;
  accessoryCustomizationModalProps: AccessoryCustomizationModalProps;
};

export const ConfiguratorAccessoryModals = ({
  faceAccessoryModalProps,
  accessoryCustomizationModalProps,
}: ConfiguratorAccessoryModalsProps) => (
  <>
    <FaceAccessoryModal
      faceId={faceAccessoryModalProps.faceId}
      widthValue={faceAccessoryModalProps.widthValue}
      hasAccessory={faceAccessoryModalProps.hasAccessory}
      onClose={faceAccessoryModalProps.onClose}
      onAddAccessory={faceAccessoryModalProps.onAddAccessory}
      onRemoveAccessory={faceAccessoryModalProps.onRemoveAccessory}
    />

    <AccessoryCustomizationModal
      faceId={accessoryCustomizationModalProps.faceId}
      partType={accessoryCustomizationModalProps.partType}
      capabilities={accessoryCustomizationModalProps.capabilities}
      mergeDoors={accessoryCustomizationModalProps.mergeDoors}
      mergeDoorCount={accessoryCustomizationModalProps.mergeDoorCount}
      movementValue={accessoryCustomizationModalProps.movementValue}
      secondaryMovementValue={accessoryCustomizationModalProps.secondaryMovementValue}
      isLeftValue={accessoryCustomizationModalProps.isLeftValue}
      textureValue={accessoryCustomizationModalProps.textureValue}
      textureSecondaryValue={accessoryCustomizationModalProps.textureSecondaryValue}
      onClose={accessoryCustomizationModalProps.onClose}
      onMovementChange={accessoryCustomizationModalProps.onMovementChange}
      onSecondaryMovementChange={accessoryCustomizationModalProps.onSecondaryMovementChange}
      onLeftRightChange={accessoryCustomizationModalProps.onLeftRightChange}
      onMergeDoorToggle={accessoryCustomizationModalProps.onMergeDoorToggle}
      onTextureChange={accessoryCustomizationModalProps.onTextureChange}
      onTextureSecondaryChange={accessoryCustomizationModalProps.onTextureSecondaryChange}
    />
  </>
);
